import { render, staticRenderFns } from "./card-evento.vue?vue&type=template&id=fff66f8a&scoped=true"
import script from "./card-evento.vue?vue&type=script&lang=js"
export * from "./card-evento.vue?vue&type=script&lang=js"
import style0 from "./card-evento.vue?vue&type=style&index=0&id=fff66f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff66f8a",
  null
  
)

export default component.exports